import { getDefaultState } from "./state";

export default {
  setLoading(state, load) {
    state.loading = load;
  },
  SET_ALL_PRODUCTS(state, { products, total, per_page }) {
    state.products = products;
    state.totalPage = total / per_page;
    state.totalItems = total;
  },

  SET_CURRENT_PRODUCT(state, product) {
    state.product = product;
  },

  UPDATE_PRODUCT(state, fields) {
    if (Object.keys(fields).length === 0) {
      state.product = {};
      return;
    }
    let copyProduct = { ...state.product };
    state.product = { ...copyProduct, ...fields };
  },

  EDIT_PRODUCT(state, product) {
    state.products = state.products.map((item) => {
      if (item.product_uuid === product.product_uuid) {
        return product;
      }

      return item;
    });
  },

  REMOVE_PRODUCT(state, product_uuid) {
    state.products = state.products.filter(
      (product) => product.product_uuid !== product_uuid
    );
  },

  SET_OPERATORS(state, operators) {
    state.operators = operators;
  },

  ADD_OPERATOR(state) {
    state.operator = {
      code: null,
      price: null,
      mobile_network_uuid: null,
    };
    const len = state.operators.length;

    //state.operators.push(state.operator);
    state.operators.splice(len, 1, state.operator);
    state.activeOperatorId = len;
  },

  REMOVE_OPERATOR(state, i) {
    state.operators.splice(i, 1);
  },

  UPDATE_ACTIVE_OPERATOR_ID(state, { operator_id, operator }) {
    state.activeOperatorId = operator_id;
    state.operator = operator;
  },

  UPDATE_OPERATOR(state, fields) {
    if (Object.keys(fields).length === 0) {
      state.operator = {};
      return;
    }
    console.log("fields", fields);
    let copyOperator = { ...state.operator };
    state.operator = { ...copyOperator, ...fields };
  },

  UPDATE_OPERATORS(state, operator) {
    state.operators = state.operators.map((item, index) => {
      if (index === state.activeOperatorId) {
        return operator;
      }
      return item;
    });
  },

  CLEAR_OPERATORS(state) {
    state.operators = [
      {
        code: null,
        price: null,
        mobile_network_uuid: null,
      },
    ];
  },

  ADD_MOBILE_NETWORK_LIST(state, { mobileNetworkList, index }) {
    // what if index = 0 and statment will be falsy
    if (!index) {
      state.allMobileNetworks.unshift(mobileNetworkList);
      return;
    }
    state.allMobileNetworks.splice(index, 1, mobileNetworkList);
    // state.allMobileNetworks[index] = mobileNetworkList;
  },

  DLETE_MOBILE_NETWORK_LIST(state, index) {
    state.allMobileNetworks.splice(index, 1);
  },

  ADD_VENDOR(state) {
    state.allVendors[state.activeOperatorId].push({
      vendor_product_uuid: null,
      mobile_network_uuid: null,
    });
  },

  UPDATE_VENDOR(state, { fields, index }) {
    let copyVendor = { ...state.allVendors[state.activeOperatorId][index] };
    state.allVendors[state.activeOperatorId][index] = {
      ...copyVendor,
      ...fields,
      ...{ mobile_network_uuid: state.operator.mobile_network_uuid },
    };
  },

  SET_ALL_VENDORS(state, { vendors, index }) {
    if (index === null) {
      state.allVendors.splice(state.activeOperatorId, 1, vendors);
      return;
    }
    state.allVendors.splice(index, 1, vendors);
  },

  REMOVE_VENDOR(state, i) {
    state.allVendors[state.activeOperatorId].splice(i, 1);
  },

  UPDATE_ALL_VENDORS(state) {
    if (!state.allVendors[state.activeOperatorId]) {
      state.allVendors.push([
        {
          vendor_product_uuid: null,
          mobile_network_uuid: null,
        },
      ]);
    } else {
      //state.allVendors[state.activeOperatorId] = state.allVendors[state.activeOperatorId];
      state.allVendors.splice(
        state.activeOperatorId,
        1,
        state.allVendors[state.activeOperatorId]
      );
    }
  },

  CLEAR_ALL_VENDORS(state) {
    state.allVendors = [
      [
        {
          vendor_product_uuid: null,
          mobile_network_uuid: null,
        },
      ],
    ];
  },

  UPDATE_NETWORK_NAME(state, networkName) {
    state.networkName = networkName;
  },

  CLEAR_ALL_MOBILE_NETWORKS(state) {
    state.allMobileNetworks = [];
  },

  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
};
